import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-2af11bb0"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "Header"
};
var _hoisted_2 = {
  "class": "Header__top"
};
var _hoisted_3 = {
  "class": "flex items-center px-2xl"
};
var _hoisted_4 = {
  key: 0,
  "class": "Header__nav"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("a", {
    href: "/riskquant/"
  }, [/*#__PURE__*/_createTextVNode(" RiskQuant "), /*#__PURE__*/_createElementVNode("sup", {
    "class": "text-primary ml-2"
  }, "beta")])], -1);
});
var _hoisted_6 = {
  "class": "PBDropdown__list"
};
var _hoisted_7 = {
  "class": "PBDropdown__item"
};
var _hoisted_8 = {
  key: 0
};
var _hoisted_9 = ["onClick"];
var _hoisted_10 = ["onClick"];
var _hoisted_11 = {
  key: 1
};
var _hoisted_12 = ["onClick"];
var _hoisted_13 = {
  "class": "PBDropdown__list"
};
var _hoisted_14 = {
  "class": "PBDropdown__item"
};
var _hoisted_15 = ["onClick"];
var _hoisted_16 = ["onClick"];
var _hoisted_17 = {
  "class": "PBDropdown__list"
};
var _hoisted_18 = {
  "class": "PBDropdown__item"
};
var _hoisted_19 = ["onClick"];
var _hoisted_20 = ["onClick"];
var _hoisted_21 = ["onClick"];
var _hoisted_22 = ["onClick"];
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("sup", {
    "class": "text-primary ml-2"
  }, "beta", -1);
});
var _hoisted_24 = {
  "class": "PBDropdown__list"
};
var _hoisted_25 = {
  "class": "PBDropdown__item"
};
var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("a", {
    href: "/analytics.html"
  }, " Analytics ")], -1);
});
var _hoisted_27 = ["onClick"];
var _hoisted_28 = ["onClick"];
var _hoisted_29 = {
  key: 0,
  "class": "Header__bottom"
};
var _hoisted_30 = {
  "class": "flex items-center px-2xl"
};
var _hoisted_31 = {
  "class": "Header__title font-bold text-2xl flex items-center"
};
var _hoisted_32 = {
  key: 2,
  "class": "text-primary ml-md"
};
var _hoisted_33 = {
  "class": "flex items-center ml-auto"
};
var _hoisted_34 = {
  "class": "mr-md"
};
import ModalLoader from "@/components/ModalLoader.vue";
import { useBanners } from "@/composables/useBanners";
import eventBus from "@/utils/eventbus";
import { GLOBAL_EVENTS } from "@/constants/global-events";

import { defineAsyncComponent, ref, computed, watch, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
export default {
  __name: 'Header',
  props: {
    empty: Boolean
  },
  setup: function setup(__props) {
    var InstructionsWithdrawModal = defineAsyncComponent({
      loader: function loader() {
        return import("@/layouts/main-layout/modals/InstructionsWithdrawModal.vue");
      },
      loadingComponent: ModalLoader
    });
    var TwoFaRequiredModal = defineAsyncComponent({
      loader: function loader() {
        return import("@/layouts/main-layout/modals/TwoFaRequiredModal.vue");
      },
      loadingComponent: ModalLoader
    });
    var NewAddressModal = defineAsyncComponent({
      loader: function loader() {
        return import("@/layouts/main-layout/modals/NewAddressModal.vue");
      },
      loadingComponent: ModalLoader
    });
    var WithdrawModal = defineAsyncComponent({
      loader: function loader() {
        return import("@/layouts/main-layout/modals/WithdrawModal.vue");
      },
      loadingComponent: ModalLoader
    });
    var TransferModal = defineAsyncComponent({
      loader: function loader() {
        return import("@/layouts/main-layout/modals/Transfer/TransferModal.vue");
      },
      loadingComponent: ModalLoader
    });
    var DepositModal = defineAsyncComponent({
      loader: function loader() {
        return import("@/layouts/main-layout/modals/DepositModal.vue");
      },
      loadingComponent: ModalLoader
    });
    var store = useStore();
    var route = useRoute();
    var router = useRouter();
    var _useBanners = useBanners(),
      banners = _useBanners.banners;
    var newAddressModalRef = ref(null);
    var pageTitle = ref("");
    var backUrl = ref("");
    var transferModalOpen = ref(false);
    var depositModalOpen = ref(false);
    var twoFaRequiredModalIsOpen = ref(false);
    var withdrawModalOpen = ref(false);
    var newAddressModalOpen = ref(false);
    var transferParams = ref(null);
    var newAddressModalInitialParams = ref(null);
    var instructionWithdrawModalOpen = ref(false);
    var isPortfolioSelectorVisible = computed(function () {
      var _store$state$portfoli;
      if (!store.state.auth.user) {
        return false;
      }
      return ((_store$state$portfoli = store.state.portfolio.portfolios) === null || _store$state$portfoli === void 0 ? void 0 : _store$state$portfoli.length) > 1;
    });
    function goTo(name, close) {
      if (route.name === name) {
        return;
      }
      router.push({
        name: name
      });
      close();
    }
    function openNewAddressModal(params) {
      newAddressModalOpen.value = true;
      newAddressModalInitialParams.value = params;
    }
    function openTransferModal() {
      var _store$state$auth$use;
      if (!((_store$state$auth$use = store.state.auth.user) !== null && _store$state$auth$use !== void 0 && _store$state$auth$use.twoFaEnabled) && !store.getters.hasPermission(store.state.config.userPermissions.BYPASS_2FA)) {
        twoFaRequiredModalIsOpen.value = true;
        transferParams.value = null;
        return;
      }
      transferModalOpen.value = true;
    }
    function openWithdrawModal() {
      var _store$state$auth$use2;
      if (!((_store$state$auth$use2 = store.state.auth.user) !== null && _store$state$auth$use2 !== void 0 && _store$state$auth$use2.twoFaEnabled) && !store.getters.hasPermission(store.state.config.userPermissions.BYPASS_2FA)) {
        twoFaRequiredModalIsOpen.value = true;
        return;
      }
      if (!store.getters.hasPermission(store.state.config.userPermissions.WITHDRAW)) {
        instructionWithdrawModalOpen.value = true;
        return;
      }
      withdrawModalOpen.value = true;
    }
    function closeNewAddressModal() {
      newAddressModalOpen.value = false;
      newAddressModalInitialParams.value = null;
    }
    function closeTransferModal() {
      transferParams.value = null;
      transferModalOpen.value = false;
    }
    eventBus.on(GLOBAL_EVENTS.OPEN_TRANSFER_MODAL, function (params) {
      transferParams.value = params;
      openTransferModal();
    });
    eventBus.on(GLOBAL_EVENTS.OPEN_NEW_ADDRESS_MODAL, openNewAddressModal);
    eventBus.on(GLOBAL_EVENTS.SET_PAGE_TITLE, function (_ref) {
      var title = _ref.title,
        url = _ref.backUrl;
      pageTitle.value = title;
      backUrl.value = url;
    });
    watch(route, function () {
      pageTitle.value = "";
      backUrl.value = "";
      withdrawModalOpen.value = false;
      if (newAddressModalOpen.value) {
        withdrawModalOpen.value = false;
      }
    });
    onBeforeUnmount(function () {
      eventBus.off(GLOBAL_EVENTS.OPEN_NEW_ADDRESS_MODAL, openNewAddressModal);
    });
    return function (_ctx, _cache) {
      var _component_PBIcon = _resolveComponent("PBIcon");
      var _component_RouterLink = _resolveComponent("RouterLink");
      var _component_PBDropdown = _resolveComponent("PBDropdown");
      var _component_CurrencySelector = _resolveComponent("CurrencySelector");
      var _component_PortfolioSelector = _resolveComponent("PortfolioSelector");
      var _component_Notifications = _resolveComponent("Notifications");
      var _component_ProfileMenu = _resolveComponent("ProfileMenu");
      var _component_HeaderBanner = _resolveComponent("HeaderBanner");
      var _component_PBButton = _resolveComponent("PBButton");
      return _openBlock(), _createElementBlock("header", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_RouterLink, {
        "class": "text-primary",
        to: "/dashboard"
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_PBIcon, {
            name: "logo",
            w: 150
          })];
        }),
        _: 1
      }), !__props.empty ? (_openBlock(), _createElementBlock("nav", _hoisted_4, [_createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_RouterLink, {
        to: "/dashboard"
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(" Dashboard ")];
        }),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_RouterLink, {
        to: "/portfolio"
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(" Portfolio ")];
        }),
        _: 1
      })]), _hoisted_5, _createElementVNode("li", null, [_createVNode(_component_PBDropdown, {
        selectable: false,
        placeholder: "Trading",
        left: ""
      }, {
        menu: _withCtx(function (_ref2) {
          var close = _ref2.close;
          return [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_unref(store).getters['trading/canTrade'] ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("a", {
            href: "#",
            onClick: _withModifiers(function ($event) {
              return goTo('trading', close);
            }, ["prevent"])
          }, " Exchange ", 8, _hoisted_9)])) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("a", {
            href: "#",
            onClick: _withModifiers(function ($event) {
              return goTo('otc', close);
            }, ["prevent"])
          }, " OTC ", 8, _hoisted_10)]), _unref(store).getters['trading/canTradeBinance'] ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("a", {
            href: "#",
            onClick: _withModifiers(function ($event) {
              return goTo('ordersAndPositions', close);
            }, ["prevent"])
          }, " Open Orders & Positions ", 8, _hoisted_12)])) : _createCommentVNode("", true)])])];
        }),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_PBDropdown, {
        selectable: false,
        placeholder: "Treasury",
        left: ""
      }, {
        menu: _withCtx(function (_ref3) {
          var close = _ref3.close;
          return [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", null, [_createElementVNode("a", {
            href: "#",
            onClick: _withModifiers(function ($event) {
              return goTo('loans', close);
            }, ["prevent"])
          }, " Loans ", 8, _hoisted_15)]), _createElementVNode("div", null, [_createElementVNode("a", {
            href: "#",
            onClick: _withModifiers(function ($event) {
              return goTo('earn', close);
            }, ["prevent"])
          }, " Earn ", 8, _hoisted_16)])])])];
        }),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_RouterLink, {
        to: "/defi"
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(" DeFi ")];
        }),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_PBDropdown, {
        selectable: false,
        placeholder: "Reports",
        left: ""
      }, {
        menu: _withCtx(function (_ref4) {
          var close = _ref4.close;
          return [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", null, [_createElementVNode("a", {
            href: "#",
            onClick: _withModifiers(function ($event) {
              return goTo('trades', close);
            }, ["prevent"])
          }, " Trades ", 8, _hoisted_19)]), _createElementVNode("div", null, [_createElementVNode("a", {
            href: "#",
            onClick: _withModifiers(function ($event) {
              return goTo('transactions', close);
            }, ["prevent"])
          }, " Transactions ", 8, _hoisted_20)]), _createElementVNode("div", null, [_createElementVNode("a", {
            href: "#",
            onClick: _withModifiers(function ($event) {
              return goTo('turnover', close);
            }, ["prevent"])
          }, " Fees & Turnover ", 8, _hoisted_21)]), _createElementVNode("div", null, [_createElementVNode("a", {
            href: "#",
            onClick: _withModifiers(function ($event) {
              return goTo('pnl', close);
            }, ["prevent"])
          }, [_createTextVNode(" Profit & Loss "), _hoisted_23], 8, _hoisted_22)])])])];
        }),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_PBDropdown, {
        selectable: false,
        placeholder: "More",
        left: ""
      }, {
        menu: _withCtx(function (_ref5) {
          var close = _ref5.close;
          return [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_hoisted_26, _createElementVNode("div", null, [_createElementVNode("a", {
            href: "#",
            onClick: _withModifiers(function ($event) {
              return goTo('list', close);
            }, ["prevent"])
          }, " Accounts ", 8, _hoisted_27)]), _createElementVNode("div", null, [_createElementVNode("a", {
            href: "#",
            onClick: _withModifiers(function ($event) {
              return goTo('currencies', close);
            }, ["prevent"])
          }, " Currencies Availability ", 8, _hoisted_28)])])])];
        }),
        _: 1
      })])])])) : _createCommentVNode("", true), _createElementVNode("div", {
        "class": _normalizeClass({
          'flex items-center ml-auto': true,
          hidden: __props.empty && !_unref(store).state.auth.user
        })
      }, [!__props.empty ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(_component_CurrencySelector, {
        header: ""
      }), _unref(isPortfolioSelectorVisible) ? (_openBlock(), _createBlock(_component_PortfolioSelector, {
        key: 0,
        "class": "ml-xl"
      })) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), _unref(store).state.auth.user ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        "class": _normalizeClass(["relative flex items-center ml-xl pl-xl before:absolute before:top-1/2 before:left-0 before:w-[1px] before:h-[24px] before:bg-zinc-700 before:translate-y-[-50%]", {
          'before:hidden': __props.empty
        }])
      }, [!__props.empty ? (_openBlock(), _createBlock(_component_Notifications, {
        key: 0,
        "class": "mr-xl"
      })) : _createCommentVNode("", true), _createVNode(_component_ProfileMenu, {
        empty: __props.empty
      }, null, 8, ["empty"])], 2)) : _createCommentVNode("", true)], 2)])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(banners), function (banner) {
        return _openBlock(), _createBlock(_component_HeaderBanner, {
          key: banner.type,
          banner: banner
        }, null, 8, ["banner"]);
      }), 128)), _unref(route).meta.page !== 'not-found' && !__props.empty ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_unref(backUrl) && !_unref(route).meta.back ? (_openBlock(), _createBlock(_component_RouterLink, {
        key: 0,
        to: _unref(backUrl)
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_PBIcon, {
            name: "chevron",
            w: 12,
            h: 7
          })];
        }),
        _: 1
      }, 8, ["to"])) : _createCommentVNode("", true), _unref(route).meta.back ? (_openBlock(), _createElementBlock("a", {
        key: 1,
        href: "#",
        onClick: _cache[0] || (_cache[0] = _withModifiers(function ($event) {
          return _unref(router).back();
        }, ["prevent"]))
      }, [_createVNode(_component_PBIcon, {
        name: "chevron",
        w: 12,
        h: 7
      })])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(_unref(pageTitle) || _unref(route).meta.title) + " ", 1), _unref(route).meta.beta ? (_openBlock(), _createElementBlock("sup", _hoisted_32, "beta")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_createVNode(_component_PBButton, {
        bordered: "",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return depositModalOpen.value = true;
        })
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(" Deposit ")];
        }),
        _: 1
      })]), _createVNode(_component_PBButton, {
        "class": "mr-md",
        bordered: "",
        onClick: openWithdrawModal
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(" Withdraw ")];
        }),
        _: 1
      }), _createVNode(_component_PBButton, {
        onClick: openTransferModal
      }, {
        "default": _withCtx(function () {
          return [_createTextVNode(" Transfer ")];
        }),
        _: 1
      })])])])) : _createCommentVNode("", true), !__props.empty ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_unref(depositModalOpen) ? (_openBlock(), _createBlock(_unref(DepositModal), {
        key: 0,
        onClose: _cache[2] || (_cache[2] = function ($event) {
          return depositModalOpen.value = false;
        })
      })) : _createCommentVNode("", true), (_unref(store).state.auth.user.twoFaEnabled || _unref(store).getters.hasPermission(_unref(store).state.config.userPermissions.BYPASS_2FA)) && _unref(transferModalOpen) ? (_openBlock(), _createBlock(_unref(TransferModal), {
        key: 1,
        params: _unref(transferParams),
        onClose: closeTransferModal
      }, null, 8, ["params"])) : _createCommentVNode("", true), (_unref(store).state.auth.user.twoFaEnabled || _unref(store).getters.hasPermission(_unref(store).state.config.userPermissions.BYPASS_2FA)) && (_unref(store).getters.hasPermission(_unref(store).state.config.userPermissions.WITHDRAW) || _unref(store).getters.hasPermission(_unref(store).state.config.userPermissions.MANAGE_WITHDRAW_ADDRESSES)) && _unref(withdrawModalOpen) ? (_openBlock(), _createBlock(_unref(WithdrawModal), {
        key: 2,
        onClose: _cache[3] || (_cache[3] = function ($event) {
          return withdrawModalOpen.value = false;
        })
      })) : _createCommentVNode("", true), !_unref(store).getters.hasPermission(_unref(store).state.config.userPermissions.WITHDRAW) && !_unref(store).getters.hasPermission(_unref(store).state.config.userPermissions.MANAGE_WITHDRAW_ADDRESSES) && _unref(instructionWithdrawModalOpen) ? (_openBlock(), _createBlock(_unref(InstructionsWithdrawModal), {
        key: 3,
        onClose: _cache[4] || (_cache[4] = function ($event) {
          return instructionWithdrawModalOpen.value = false;
        })
      })) : _createCommentVNode("", true), _unref(store).getters.hasPermission(_unref(store).state.config.userPermissions.MANAGE_WITHDRAW_ADDRESSES) && _unref(newAddressModalOpen) ? (_openBlock(), _createBlock(_unref(NewAddressModal), {
        key: 4,
        ref_key: "newAddressModalRef",
        ref: newAddressModalRef,
        "initial-params": _unref(newAddressModalInitialParams),
        onClose: closeNewAddressModal
      }, null, 8, ["initial-params"])) : _createCommentVNode("", true), _unref(twoFaRequiredModalIsOpen) ? (_openBlock(), _createBlock(_unref(TwoFaRequiredModal), {
        key: 5,
        onClose: _cache[5] || (_cache[5] = function ($event) {
          return twoFaRequiredModalIsOpen.value = false;
        })
      })) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]);
    };
  }
};